import React, { useEffect, useState } from 'react';
import * as echarts from 'echarts';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, FormControl, Button, TextField } from '@mui/material';

import { createTiltCoordinates } from 'utils/Map/mapUtils';

import 'assets/styles/MarkerTable.scss';

// Define the props interface with arrays of numbers
interface ElevationChartProps {
  points: any;
  actualTilt: number;
  linesData: number[];
  hideTiltLine: boolean;
  distanceSteps: number[];
  closeElevation: () => void;
  earthElevationData: number[];
}

const ElevationChart: React.FC<ElevationChartProps> = ({
  points,
  linesData,
  actualTilt,
  hideTiltLine,
  distanceSteps,
  closeElevation,
  earthElevationData,
}) => {
  const [tilt, setTilt] = useState<number>();
  const [altitude, setAltitude] = useState<number>();
  const [tiltedLine, setTiltedLine] = useState<any>([]);

  const handleApply = () => {
    setTiltedLine(createTiltCoordinates(points, tilt, altitude));
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleApply();
    }
  };

  useEffect(() => {
    if (earthElevationData) {
      var chartDom = document.getElementById('elevation-chart');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        notMerge: true,
        title: {
          text: 'Elevation Chart',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
            },
          },
        },
        legend: {
          data: ['Earth elevation'],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: distanceSteps,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: 'Earth elevation',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series',
            },
            data: earthElevationData,
          },
        ],
      };

      if (!hideTiltLine) {
        option.series.push({
          name: 'Cell coverage(' + actualTilt + ' deg)',
          type: 'line',
          data: linesData,
        });
        option.legend.data.push('Cell coverage(' + actualTilt + ' deg)');
      }

      if (tiltedLine) {
        option.series.push({
          name: 'Tilted line',
          type: 'line',
          data: tiltedLine.map((line) => line[2]),
        });
        option.legend.data.push('Tilted line');
      }

      option && myChart.setOption(option);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [earthElevationData, tiltedLine]);

  return (
    <>
      <Box className="elevation-chart">
        <Box className="elevation-form-controls">
          <FormControl>
            <TextField
              size="small"
              value={tilt}
              type="number"
              id="tilt-input"
              variant="outlined"
              placeholder="Tilt"
              onKeyDown={handleKeyPress}
              onChange={(e) => setTilt(Number(e.target.value))}
            />
          </FormControl>
          <FormControl>
            <TextField
              size="small"
              type="number"
              value={altitude}
              variant="outlined"
              id="altitude-input"
              placeholder="Altitude"
              onKeyDown={handleKeyPress}
              onChange={(e) => setAltitude(Number(e.target.value))}
            />
          </FormControl>
          <Button variant="contained" onClick={handleApply}>
            Apply
          </Button>
        </Box>
        <Box className="close-icon">
          <IconButton aria-label="Close">
            <CloseIcon onClick={closeElevation} />
          </IconButton>
        </Box>
        <Box
          id="elevation-chart"
          style={{ width: '100%', height: '100%' }}
        ></Box>
      </Box>
    </>
  );
};

export default ElevationChart;
